import React from 'react';

const FilterTag = ({ value, onClose }) => (
  <div
    style={{
      margin: '10px 5px',
      padding: '2px',
      color: 'black',
      fontFamily: 'sans-serif',
      fontSize: '1.3rem',
    }}
  >
    {value}
    <span onClick={onClose}>
      <svg
        width="15"
        height="15"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.96 12.75L19.5 18.29V19.75H18.04L12.5 14.21L6.96 19.75H5.5V18.29L11.04 12.75L5.5 7.21V5.75H6.96L12.5 11.29L18.04 5.75H19.5V7.21L13.96 12.75Z"
          fill="black"
        />
      </svg>
    </span>
  </div>
);

const ActiveFiltersDisplay = ({
  from,
  filterQuery,
  properties,
  selectedPropertyCommonAreas,
  items,
  buildingsList,
  levelsList,
  filterServiceProviderandPropertyDeveloperList,
  setFilterData,
}) => {
  if (from === 'dashboard') return null;

  const renderFilterTags = () => {
    const commonAreasData = selectedPropertyCommonAreas || [];
    let projectName = properties.find(
      (item: any) => item.propertyId === filterQuery.project
    );
    let commonAreas = commonAreasData.filter(
      (item: any) => item.id === filterQuery.commonAreas
    )[0];
    let assetName = items.find((item) => item.typeId === filterQuery.assetType);
    let buildingName = buildingsList.find(
      (item: any) => item.id === filterQuery.building
    );
    let levelName = levelsList.find((item) => item.id === filterQuery.level);
    let assignTo = filterServiceProviderandPropertyDeveloperList.find(
      (item: any) => item.id === filterQuery.assignTo
    );

    return (
      <>
        {filterQuery.walkthrough?.map((item) => (
          <FilterTag
            key={item}
            value={item}
            onClose={() => {
              let value = {
                ...filterQuery,
                walkthrough: filterQuery.walkthrough.filter(
                  (type) => type !== item
                ),
              };
              setFilterData(value);
            }}
          />
        ))}
        {filterQuery.startDate && (
          <FilterTag
            value={filterQuery.startDate + ' to ' + filterQuery.endDate}
            onClose={() => {
              let value = { ...filterQuery, startDate: '', endDate: '' };
              setFilterData(value);
            }}
          />
        )}
        {filterQuery.project && (
          <FilterTag
            value={projectName.name}
            onClose={() => {
              let value = {
                ...filterQuery,
                project: '',
                suite: [],
                building: '',
                level: '',
                commonAreas: '',
              };
              setFilterData(value);
            }}
          />
        )}
        {filterQuery.commonAreas && (
          <FilterTag
            value={commonAreas === undefined ? '' : commonAreas.name}
            onClose={() => {
              let value = { ...filterQuery, commonAreas: '' };
              setFilterData(value);
            }}
          />
        )}
        {filterQuery.suite?.map((item) => (
          <FilterTag
            key={item.name}
            value={item.name}
            onClose={() => {
              let value = {
                ...filterQuery,
                suite: filterQuery.suite.filter(
                  (type) => type.name !== item.name
                ),
              };
              setFilterData(value);
            }}
          />
        ))}
        {filterQuery.tags?.map((item) => (
          <FilterTag
            key={item.value}
            value={item.label}
            onClose={() => {
              let value = {
                ...filterQuery,
                tags: filterQuery.tags.filter(
                  (type) => type.value !== item.value
                ),
              };
              setFilterData(value);
            }}
          />
        ))}
        {filterQuery.issueType && (
          <FilterTag
            value={filterQuery.issueType}
            onClose={() => {
              let value = { ...filterQuery, issueType: '' };
              setFilterData(value);
            }}
          />
        )}
        {filterQuery.assetType && (
          <FilterTag
            value={assetName.typeName}
            onClose={() => {
              let value = { ...filterQuery, assetType: '' };
              setFilterData(value);
            }}
          />
        )}
        {filterQuery.building && (
          <FilterTag
            value={buildingName.building}
            onClose={() => {
              let value = { ...filterQuery, building: '', level: '' };
              setFilterData(value);
            }}
          />
        )}
        {filterQuery.level && (
          <FilterTag
            value={levelName.level}
            onClose={() => {
              let value = { ...filterQuery, level: '' };
              setFilterData(value);
            }}
          />
        )}
        {filterQuery.assignTo && (
          <FilterTag
            value={`${assignTo.firstname} ${assignTo.lastname}`}
            onClose={() => {
              let value = { ...filterQuery, assignTo: '' };
              setFilterData(value);
            }}
          />
        )}
      </>
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
      }}
    >
      {renderFilterTags()}
    </div>
  );
};

export default ActiveFiltersDisplay;
